
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const events = createApi({
    reducerPath: 'events',
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['Events'],
    endpoints: (builder) => ({

        getEvents: builder.query({
            query: ({ page = 1, limit = 10, search }) => `/api/event/get-events?page=${page}&limit=${limit}&search=${search}`,
            providesTags: (result, error, { page, limit }) => [
                { type: 'Events', id: `page-${page}-limit-${limit}` },
            ],
        }),

        createEvent: builder.mutation({
            query: (data) => ({
                url: `/api/event/create-new-event`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Events'],
        }),

        deleteEvent: builder.mutation({
            query: (id) => ({
                url: `api/event/delete-event/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Events'],
        }),


        updateEvent: builder.mutation({
            query: (data) => ({
                url: `/api/event/update-event`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Events'],
        }),
    }),
});

export const {
    useGetEventsQuery,
    useCreateEventMutation,
    useDeleteEventMutation,
    useUpdateEventMutation
} = events;